const SWATCH_SEPARATOR = "\u001f";

export function swatchKey(code: string, value: string) {
  return `${code}${SWATCH_SEPARATOR}${value}`;
}
